import { Injectable, inject } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events';
import { MarginSetupStore } from './margin-setup.store';

@Injectable({ providedIn: 'root' })
export class MarginSetupReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginSetupStore = inject(MarginSetupStore);

    constructor() {
        this.listenToMarginSetupEvent();
    }

    private listenToMarginSetupEvent() {
        this.eventBus.on(LocumsMarginCalculatorEvents.CONTRACT_START_DATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ contractStartDate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.CONTRACT_END_DATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ contractEndDate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.DAYS_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ days: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.HOURS_PER_SHIFT_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ hoursPerShift: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.BILL_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ billRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.PAY_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ payRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.OVERTIME_BILL_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ overtimeBillRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.OVERTIME_PAY_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ overtimePayRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.OVERTIME_RATE_FACTOR_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ overtimeRateFactor: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.HOLIDAY_BILL_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ holidayBillRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.HOLIDAY_PAY_RATE_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ holidayPayRate: event.payload });
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.HOLIDAY_RATE_FACTOR_CHANGED).subscribe((event: EventPayload) => {
            this.marginSetupStore.updateMarginSetupField({ holidayRateFactor: event.payload });
        });
    }
}
